import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={93}
      height={93}
      viewBox="0 0 93 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_9345_1661)">
        <Path
          d="M52.083 87.092v2.323a3.584 3.584 0 007.169 0v-2.323h-7.169zM55.667 48.313c-1.217 0-2.6-.09-3.77-.262V62.23a.559.559 0 00.558.57h6.797V48.05c-1.17.173-2.367.263-3.585.263z"
          fill="#BC7C63"
        />
        <Path
          d="M55.916 89.415v-2.323h-3.832v2.323A3.584 3.584 0 0055.668 93c.705 0 1.361-.207 1.916-.559a3.579 3.579 0 01-1.668-3.026zM55.667 48.313c-1.217 0-2.6-.09-3.77-.262V62.23a.559.559 0 00.558.57h3.46V48.309c-.082.001-.164.005-.248.005z"
          fill="#AB6B51"
        />
        <Path
          d="M65.207 62.24H52.642a.559.559 0 01-.559-.572V51.47c0-1.23-.995-2.233-2.226-2.238h-.011a3.183 3.183 0 00-2.886 1.837c-1.183 2.534-.825 5.326-4.535 9.019-1.83 1.822-4.325 2.819-6.908 2.819h-3.375v21.921h2.141c1.83 0 3.63.454 5.242 1.32a11.075 11.075 0 005.241 1.318H60.9a3.153 3.153 0 100-6.306h1.436a3.153 3.153 0 100-6.307h1.436a3.153 3.153 0 100-6.306h1.436a3.153 3.153 0 000-6.307z"
          fill="#FED2A4"
        />
        <Path
          d="M37.57 65.67c0-1.462.717-2.755 1.818-3.549a9.926 9.926 0 01-3.87.785h-3.376v21.922h2.141c1.119 0 2.226.171 3.286.5V65.67z"
          fill="#FFBD86"
        />
        <Path
          d="M55.668 48.874c13.496 0 24.437-10.94 24.437-24.437C80.105 10.941 69.164 0 55.668 0 42.17 0 31.23 10.94 31.23 24.437c0 13.497 10.941 24.437 24.438 24.437z"
          fill="#43CB8E"
        />
        <Path
          d="M36.532 24.437c0-12.6 9.537-22.972 21.787-24.294A24.72 24.72 0 0055.668 0C42.17 0 31.23 10.94 31.23 24.437c0 13.497 10.941 24.437 24.438 24.437.895 0 1.78-.05 2.65-.143-12.249-1.322-21.786-11.693-21.786-24.294z"
          fill="#00BA66"
        />
        <Path
          d="M55.668 44.032c10.822 0 19.595-8.773 19.595-19.595S66.49 4.842 55.668 4.842s-19.596 8.773-19.596 19.595 8.773 19.595 19.596 19.595z"
          fill="#00BA66"
        />
        <Path
          d="M41.374 24.437c0-9.923 7.376-18.122 16.945-19.416a19.758 19.758 0 00-2.651-.18c-10.822 0-19.596 8.774-19.596 19.596 0 10.822 8.774 19.595 19.596 19.595.899 0 1.784-.062 2.65-.179-9.568-1.294-16.944-9.493-16.944-19.416z"
          fill="#00A855"
        />
        <G fill="#FFBD86">
          <Path d="M60.9 81.16h1.436-8.65a1.403 1.403 0 000 2.806h10.347a3.153 3.153 0 00-3.133-2.807zM63.772 74.853H53.686a1.403 1.403 0 000 2.806h11.783a3.153 3.153 0 00-3.133-2.806h1.436zM53.686 71.353h13.22a3.153 3.153 0 00-3.134-2.807H53.686a1.403 1.403 0 000 2.807zM65.207 62.24H53.062c-.462.283-.78.852-.78 1.403 0 .775.629 1.403 1.404 1.403H68.34a3.153 3.153 0 00-3.134-2.807z" />
        </G>
        <Path
          d="M31.453 60.542h-5.799v26.015h5.8c.69 0 1.25-.56 1.25-1.25V61.792c0-.691-.56-1.251-1.25-1.251z"
          fill="#DFEBFA"
        />
        <Path d="M25.654 60.542h4.112v26.015h-4.112V60.542z" fill="#B1DBFC" />
        <Path
          d="M24.427 58.148h-9.744c-.987 0-1.788.8-1.788 1.788v27.226c0 .987.8 1.788 1.788 1.788h9.744c.988 0 1.788-.8 1.788-1.788V59.936c0-.987-.8-1.788-1.788-1.788z"
          fill="#60B8FE"
        />
        <Path
          d="M19.555 87.162V59.936c0-.987.8-1.788 1.788-1.788h-6.66c-.987 0-1.788.8-1.788 1.788v27.226c0 .987.8 1.788 1.788 1.788h6.66c-.987 0-1.788-.8-1.788-1.788z"
          fill="#23A8FE"
        />
        <Path
          d="M66.69 17.913a2.914 2.914 0 00-4.218-.102l-8.505 8.504c-.229.23-.6.23-.829 0l-3.8-3.8a2.914 2.914 0 00-4.218.102c-1.056 1.16-.954 2.968.156 4.077l6.216 6.217a2.914 2.914 0 004.121 0L66.534 21.99c1.11-1.11 1.212-2.917.156-4.077z"
          fill="#DFEBFA"
        />
        <Path
          d="M54.305 31.195l-6.217-6.216c-.886-.887-1.128-2.219-.65-3.31a2.905 2.905 0 00-2.318.948c-1.056 1.16-.954 2.968.156 4.077l6.216 6.217a2.914 2.914 0 004.121 0l.867-.867a2.902 2.902 0 01-2.175-.848z"
          fill="#B1DBFC"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_9345_1661">
          <Path fill="#fff" d="M0 0H93V93H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
